import { X } from "@phosphor-icons/react";
import clsx from "clsx";

import { Button } from "common/components/ui/Button";
import { Tag } from "common/components/ui/Tag";

import type { ReactNode } from "react";

interface DataTableSelectionBarProps {
  rowsCount: number;
  selectedRowsCount: number;
  children: ReactNode;
  onClear: () => void;
}

export default function DataTableSelectionBar({
  rowsCount,
  selectedRowsCount,
  children,
  onClear,
}: DataTableSelectionBarProps) {
  return (
    <div
      className={clsx(
        "z-10 flex w-fit flex-row items-center justify-center gap-3 rounded-2xl border border-black-200 bg-white p-1 py-2.5 px-3 shadow-xl sticky bottom-6 mx-auto",
        rowsCount === 1 ? "-mt-17 mb-3.5" : "-mt-19.5 mb-6",
      )}
    >
      <div className="flex flex-row items-center gap-1.5">
        <Tag variant="primary" size="sm">
          {selectedRowsCount}
        </Tag>
        <span className="text-button-xs text-black-500">Selected</span>
      </div>

      <div className="flex flex-row gap-2">{children}</div>

      <Button
        size="sm"
        variant="ghost-black"
        intent="iconOnly"
        type="button"
        onClick={onClear}
        aria-label="Clear selection"
      >
        <X className="text-black-500" />
      </Button>
    </div>
  );
}
